/**
 * The bold line of a note (QA batch 11). Work notes have no title of their own,
 * so the profile's Notes card said "No title": they show the work's name, or
 * nothing where the work name is already shown as a chip (Notes tab cards).
 * A titled work note shows "Work name: Title" there (QA batch 14, NOTE-030).
 */
export const noteHeading = (
  note: {
    title?: string | null;
    workId?: string | null;
    workName?: string | null;
  },
  workShownElsewhere = false,
) => {
  const title = (note.title || "").trim();
  const workName = (note.workName || "").trim();
  // A titled work note also names its work where no work chip is shown (NOTE-030).
  if (title)
    return workName && !workShownElsewhere ? `${workName}: ${title}` : title;
  if (note.workId || note.workName)
    return workShownElsewhere ? "" : (note.workName || "").trim();
  return "No title";
};
